module.exports = function plotRange2BBox(plotRange) {
  return {
    minX: plotRange.tl.x,
    minY: plotRange.tl.y,
    maxX: plotRange.br.x,
    maxY: plotRange.br.y
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/chart/util/plot-range2bbox.js
// module id = 203
// module chunks = 0 1 2